export function configToString(config: Record<string, unknown> | null) {
    if (!config) {
        return;
    }
    return Object.keys(config)
        .reduce((result, key) => {
            const value = config[key];

            return result + `${key}=${value}\n`;
        }, '')
        .trim();
}

export function stringToConfig(stringValue: string | null) {
    if (!stringValue) {
        return {};
    }
    return stringValue.split('\n').reduce((config: Record<string, string>, line: string) => {
        if (line.trim() === '') {
            return config;
        }

        const [prop, value = ''] = line.split('=');

        config[prop!.trim()] = value.trim();
        return config;
    }, {});
}
